package tta.destinigo.talktoastro.feature_profile.edit_profile.di

import org.koin.dsl.module
import tta.destinigo.talktoastro.feature_profile.edit_profile.data.EditProfileApiService
import tta.destinigo.talktoastro.feature_profile.edit_profile.domain.EditProfileUserUseCases

val editProfileCommonModule  = module {
    single { EditProfileApiService() }
    single { EditProfileUserUseCases(get()) }
}